import axios from "axios";
import { useAuth } from "./auth.service";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API;

export const useMessagesService = () => {
  const { user } = useAuth();

  const getAuthHeaders = () => ({
    "Content-Type": "application/json",
    "x-access-token": user?.accessToken,
  });

  // Filter messages for specific template in current week
  const filterMessagesByTemplate = async (templateName, period = 'week', page = 1, limit = 50) => {
    try {
      const params = new URLSearchParams({
        template_name: templateName,
        period,
        page: page.toString(),
        limit: limit.toString()
      });

      const response = await axios.get(
        `${API_BASE_URL}/messages/filter?${params.toString()}`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error filtering messages by template:", error);
      throw error;
    }
  };

  // Filter messages by period only
  const filterMessagesByPeriod = async (period = 'day', page = 1, limit = 50) => {
    try {
      const params = new URLSearchParams({
        period,
        page: page.toString(),
        limit: limit.toString()
      });

      const response = await axios.get(
        `${API_BASE_URL}/messages/filter?${params.toString()}`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error filtering messages by period:", error);
      throw error;
    }
  };

  // Get statistics for all templates in current month
  const getMessagesStatistics = async (period = 'month') => {
    try {
      const params = new URLSearchParams({
        period
      });

      const response = await axios.get(
        `${API_BASE_URL}/messages/statistics?${params.toString()}`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error getting messages statistics:", error);
      throw error;
    }
  };

  // Get statistics for custom date range
  const getMessagesStatisticsCustomRange = async (startDate, endDate) => {
    try {
      const params = new URLSearchParams({
        period: 'custom',
        start_date: startDate,
        end_date: endDate
      });

      const response = await axios.get(
        `${API_BASE_URL}/messages/statistics?${params.toString()}`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error getting messages statistics for custom range:", error);
      throw error;
    }
  };

  // Generic method to execute any query with custom parameters
  const executeQuery = async (endpoint, params = {}) => {
    try {
      const searchParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          searchParams.append(key, value.toString());
        }
      });

      const response = await axios.get(
        `${API_BASE_URL}${endpoint}?${searchParams.toString()}`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error(`Error executing query ${endpoint}:`, error);
      throw error;
    }
  };

  return {
    filterMessagesByTemplate,
    filterMessagesByPeriod,
    getMessagesStatistics,
    getMessagesStatisticsCustomRange,
    executeQuery
  };
};
